export const EXPAND_SECTION = 'EXPAND_SECTION';
export const COLLAPSE_SECTION = 'COLLAPSE_SECTION';

export const expandSection = id => {
  return {
    type: EXPAND_SECTION,
    id,
  };
};

export const collapseSection = id => {
  return {
    type: COLLAPSE_SECTION,
    id,
  };
};
